import type { ButtonProps } from '@mantine/core';

/**
 * Mantine `loading` keeps filled colors; use light/gray styling while busy
 * so Create/Delete actions read as disabled immediately on click.
 */
export function busyActionButtonProps(
  busy: boolean,
  color?: ButtonProps['color'],
): Partial<ButtonProps> {
  if (!busy) {
    return color ? { color, variant: 'filled' } : { variant: 'filled' };
  }

  return {
    variant: 'light',
    color: color ?? 'gray',
    styles: {
      root: {
        cursor: 'not-allowed',
        opacity: 0.72,
        filter: 'grayscale(0.4)',
        borderColor: 'var(--mantine-color-default-border)',
        color: 'var(--app-action-disabled, var(--mantine-color-dimmed))',
        backgroundColor: 'var(--mantine-color-default-hover)',
      },
    },
  };
}
